'use client';

import type { PropsWithChildren } from 'react';
import { memo } from 'react';
import { AssetsDnDContextProvider } from '../AssetsDnDContext';
import type { SelectionContext } from '../SelectionContext/SelectionContext';
import { createSelectionContext } from '../SelectionContext/SelectionContext';

const {
  SelectionContextProvider: AssetSelectionContextProvider,
  useIsSelected,
  useKnownSelectedIds,
  useSelectionCount,
  useSelectionSet,
  useSelectionState,
  useSetSelectedIds,
  useRangeSelectionState,
  useSelectedIndices,
} = createSelectionContext();

export type InitialAssetSelectionState = Omit<SelectionContext, 'setState'>;

export const AssetsContextProvider = memo<
  PropsWithChildren<{
    initialAssetSelectionState?: InitialAssetSelectionState;
  }>
>(({ children, initialAssetSelectionState }) => {
  return (
    <AssetsDnDContextProvider>
      <AssetSelectionContextProvider initialState={initialAssetSelectionState}>
        {children}
      </AssetSelectionContextProvider>
    </AssetsDnDContextProvider>
  );
});

export const useIsAssetSelected = useIsSelected;
export const useSelectedAssets = useKnownSelectedIds;
export const useSelectedAssetIndices = useSelectedIndices;
export const useSelectedAssetCount = useSelectionCount;
export const useAssetsSelectionSet = useSelectionSet;
export const useAssetSelectionState = useSelectionState;
export const useSetSelectedAssets = useSetSelectedIds;
export const useAssetRangeSelectionState = useRangeSelectionState;
